import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpErrorResponse } from '@angular/common/http';
import { JwtHelperService } from '@auth0/angular-jwt';
import { environment } from 'src/environments/environment';
import { Router } from '@angular/router';
import { AlertifyService } from './alertify.service';
import { MatDialog } from '@angular/material';
import { UserViewModel } from '../_models/user.viewmodel';
import { UserViewModelResponse } from '../_models/user-response.viewmodel';
import { HttpService } from './http.service';
import { AuthConfigService } from './auth-config.service';

@Injectable({
  providedIn: 'root'
})
export class AuthService {

  baseUrl = environment.apiUrl;
  baseWAuthUrl = environment.apiWindowsAuthUrl;
 
  jwtHelper = new JwtHelperService();
  decodedToken: any;
  userToken: any;
  private httpHeaders: HttpHeaders;
  model: any = {};
  inValidLogin: any = [];
  inValidDBUser: any = [];
  validLogin: any = [];
  userLockedOut: any = [];
  response: any = {};
  userIsInactive: any = {};
  public userViewModel: UserViewModel;
  isLoading = false;

    constructor(
     private http: HttpClient,
     private router: Router, 
     private alertify: AlertifyService, 
     private dialog: MatDialog, 
     private httpService: HttpService,
     private authConfigService: AuthConfigService) {
    this.httpHeaders = new HttpHeaders({
      'Content-Type': 'application/json',
      Accept: 'application/json'
    });
    
    this.initializeDecodedToken();
  }

  private initializeDecodedToken() {
    try {
      const token = localStorage.getItem('token');
      if (token) {
        if (this.jwtHelper.isTokenExpired(token)) {
          localStorage.removeItem('token');
          this.decodedToken = null;
          return;
        }
        this.decodedToken = this.jwtHelper.decodeToken(token);
      }
    } catch (error) {
      localStorage.removeItem('token');
      this.decodedToken = null;
    }
  }

   login(model: any) {
    this.isLoading = true;
    return this.http.post(this.baseUrl + 'account/login', model, {observe: 'response'}).subscribe(
      (res: any) => {
        this.response = res;
        this.validLogin = res.headers.get('loginValid');
        if (this.validLogin !== null) {
          localStorage.setItem('token', res.body.token);
          this.decodedToken = this.jwtHelper.decodeToken(res.body.token);
          this.router.navigate(['/search']);
          this.alertify.success(this.validLogin);
          this.dialog.closeAll();
          this.isLoading = false;
        }
        this.inValidDBUser = res.headers.get('invalidemailformat');
        this.inValidLogin = res.headers.get('logininvalid');
        this.userLockedOut = res.headers.get('lockedOut');
        if (this.inValidDBUser) {
          this.alertify.message(this.inValidDBUser);
          this.isLoading = false;
        }
        if (this.inValidLogin) {
          this.alertify.error(this.inValidLogin);
          this.isLoading = false;
        }
        if (this.userLockedOut) {
          this.alertify.warning(this.userLockedOut);
          this.isLoading = false;
        }
      },
      error => {
        this.isLoading = false;
      }
    );
  }

  getUserEmail() {
    const token = localStorage.getItem('token');
    const information = this.jwtHelper.decodeToken(token);
    const userEmail = information.email;
    return userEmail;
  }

  roleFromToken(allowedRoles): boolean {
    let isMatch = false;
    const userRoles = this.decodedToken.role as Array<string>;
    allowedRoles.forEach(element => {
      if (userRoles.includes(element)) {
        isMatch = true;
        return;
      }
    });
    return isMatch;
  }

  register(model: any) {
    return this.http.post(this.baseUrl + 'account/register', model);
  }

  loggedIn() {
    try {
      const token = localStorage.getItem('token');
      if (!token) {
        return false;
      }
      return !this.jwtHelper.isTokenExpired(token);
    } catch (error) {
      console.warn('Invalid token detected, clearing:', error);
      localStorage.removeItem('token');
      return false;
    }
  }

  loggedInWindowsUser() {
    try {
      const token = localStorage.getItem('token');
      if (!token) {
        return false;
      }
      return !this.jwtHelper.isTokenExpired(token);
    } catch (error) {
      console.warn('Invalid token detected, clearing:', error);
      localStorage.removeItem('token');
      return false;
    }
  }

  logout() {
    localStorage.removeItem('token');
    this.decodedToken = null;
    this.authConfigService.refreshAuthMode();
    this.router.navigate(['/search']);
  }

  forgotPassword(model: any) {
    return this.http.post(this.baseUrl + 'account/forgotPassword', model, {observe: 'response'});
  }

  resetPassword(model: any) {
    return this.http.post(this.baseUrl + `account/resetPassword`, model, {observe: 'response'});
  }

  resendEmail(email: string) {
    return this.http.post(this.baseUrl + `account/ResendEmail/${email}`, email, {observe: 'response'});
  }

  windowsAuthentication() {
    localStorage.removeItem('token');
    this.isLoading = true;

    let user = new UserViewModel();
    user = this.userViewModel;

    this.httpService.HttpGetWithCredentials<UserViewModelResponse>(this.baseWAuthUrl).subscribe((response: UserViewModelResponse) => {
      this.loginSuccess(response);
    }, response => this.loginFailed(response));
  }

  private loginSuccess(response) {
    localStorage.setItem('token', response.body.token);
    this.decodedToken = this.jwtHelper.decodeToken(response.body.token);

    this.isLoading = false;
    this.alertify.success('Logged in successfully');
    this.router.navigate(['/search']);
  }

  private loginFailed(error: HttpErrorResponse) {

    let errorResponse: UserViewModelResponse = error.error;
    if (!errorResponse.returnStatus) {
      localStorage.removeItem('token');
      this.isLoading = false;
      this.router.navigate(['/search']);
      }
  }
}